import services from './../../services/service'; // Service Class
import MenuModal from './../../components/menumodal.vue'
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
        user: '', 
        user_slug: {},
        products: {},
        product: {},
        items:[],
        checked_out_items: [],
        img_url: service.imageURL,
        loggedIn:false
      }
  },
  components: {
    'menu-modal': MenuModal
 },
  computed: {
    total() {
      var total = 0;
      for(var i = 0; i < this.items.length; i++) {
        total += this.items[i].product_price;
      }
      return total;
    }
},
methods: {
    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user = localStorage.getItem("sp_user");
        }
    },

    getProducts() {
        service.getProducts(this).then(data => {
            if(data.body.status == 200) {
                this.products = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    addToCart(item) {
        item.quantity = 0;
        item.quantity += 1;

        item.checked_out = false; //prepare for checkout
        this.items.push(item);
     },
    removeFromCart(item) {
        item.quantity -= 1;
        this.items.splice(this.items.indexOf(item), 1);
    },
    checkout() {
        //currently processi =ng the whole items
        //--in most cases users select the items they want to check out
        this.items.forEach(function(element) {
            element.checked_out = true;
        }, this);
        this.checked_out_items = this.items;
        this.items = [];
    },
  },
  created: function() {
      //this.getUser();
    this.checkLoggedIn();
  }
}


// WEBPACK FOOTER //
// ./src/pages/MainHeader/script.js